/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateBenefitAmountMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateBenefitAmountInput;
}>;


export type UpdateBenefitAmountMutation = { __typename?: 'Mutation', updateBenefitAmount: { __typename?: 'BenefitAmount', id: string, benefitAmount: number, expectIncomeIncrease: boolean | null } | null };


export const UpdateBenefitAmountDocument = gql`
    mutation UpdateBenefitAmount($input: UpdateBenefitAmountInput!) {
  updateBenefitAmount(input: $input) {
    id
    benefitAmount
    expectIncomeIncrease
  }
}
    `;
export type UpdateBenefitAmountMutationFn = Apollo.MutationFunction<UpdateBenefitAmountMutation, UpdateBenefitAmountMutationVariables>;
export function useUpdateBenefitAmountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBenefitAmountMutation, UpdateBenefitAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBenefitAmountMutation, UpdateBenefitAmountMutationVariables>(UpdateBenefitAmountDocument, options);
      }
export type UpdateBenefitAmountMutationHookResult = ReturnType<typeof useUpdateBenefitAmountMutation>;
export type UpdateBenefitAmountMutationResult = Apollo.MutationResult<UpdateBenefitAmountMutation>;
export type UpdateBenefitAmountMutationOptions = Apollo.BaseMutationOptions<UpdateBenefitAmountMutation, UpdateBenefitAmountMutationVariables>;